import { Component, OnInit, OnDestroy } from '@angular/core';
import { Input, Output, EventEmitter }  from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { TicketDiscount } from '@app/modules/model/ticketdiscount';

import { languageSupport, languageService } from '@app/modules/common/language'
import { viewService } from '@app/modules/view';

@Component({
    selector: 'ui-cart-discount',
    templateUrl:'./ui-cart.html',
    styleUrls: [ 
        './ui-cart.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiCartDiscount extends languageSupport implements OnInit, OnDestroy {
    @Input('discount') _discount: TicketDiscount = null;

    private _subscriptions = [];

    /***********************************/
    /* STARTS HERE                     */
    /***********************************/

    constructor(private lang: languageService, private change: ChangeDetectorRef, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        this._subscriptions.push(
            this.view.OnTheme.subscribe(
            data => {
                this.change.markForCheck();
            })
        );  

        if (this._discount){
            this._subscriptions.push(
                this._discount.OnRefresh.subscribe(
                data => {
                    this.change.markForCheck();
                })
            );                
        }
    }

    ngOnDestroy(){
        super.OnDestroy();

        for(let _subscription of this._subscriptions){
            _subscription.unsubscribe();
        }
        this._subscriptions = [];
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/
    
    DelDiscount(){
        this._discount.ticket.DiscountDel(this._discount);
    }
}
